import { getStatusLabel } from '@/utils'
// 处方详情 基本信息
const BASE_LABEL = [
  {
    label: '姓名: ',
    prop: 'patientName',
    render: record => {
      const { patientName } = record || {}
      const name = patientName || '--'
      return record?.unionPrescriptionInnerType === 2 ? '待完善' : name
    },
    class: ['noPadding']
  },
  {
    label: '性别: ',
    prop: 'patientGender',
    class: ['noBorder']
  },
  {
    label: '年龄: ',
    prop: 'patientAge',
    render: record => {
      const { patientAge } = record || {}
      const age = patientAge || patientAge === 0 ? patientAge + '岁' : '--'
      return record?.unionPrescriptionInnerType === 2 ? '待完善' : age
    },
    class: ['noBorder']
  },
  {
    label: '诊断：',
    prop: 'westernDiagnoses',
    class: ['noPadding']
  },
  {
    label: '中医证型：',
    prop: 'chineseDiagnoses'
  },
  {
    label: '医生: ',
    prop: 'doctorName',
    class: ['noBorder']
  },
  {
    label: '复诊日期: ',
    prop: 'revisitInfo',
    class: ['noPadding', 'middle']
  },
  {
    label: '开具日期: ',
    prop: 'createTime',
    class: ['noBorder']
  }
]
// 联合处方详情状态图片标签业务逻辑处理
// 显示优先级：已购买>部分购买>已失效>部分失效>已作废>部分作废>已下单未支付>未购买
export const getStatusImg = info => {
  const { status, expireStatus, invalid } = info
  return getStatusLabel({ status, expire: expireStatus, invalid })
}

// 协定方药品信息
const AGREEMENT_DRUG = [
  // 编码协定方展示--@雅俊
  { title: '编码', dataIndex: 'skuCode', key: 'skuCode' },
  { title: '药方名称', dataIndex: 'skuName', key: 'skuName' }
  // { title: '售价（元）agree', dataIndex: 'salePrice', key: 'salePrice' }
]
//中药
const CHINESE_DRUG = [
  { title: '编码', dataIndex: 'skuCode', key: 'skuCode' },
  { title: '药材名称', dataIndex: 'skuName', key: 'skuName' },
  { title: '计量（克）', dataIndex: 'quantity', key: 'quantity' }
]
//西药
const WESTERN_DRUG = [
  { title: 'sku 编码', dataIndex: 'skuCode', key: 'skuCode' },
  { title: 'sku 名称', dataIndex: 'skuName', key: 'skuName' },
  { title: '数量（盒）', dataIndex: 'quantity', key: 'quantity' },
  { title: '用法用量', dataIndex: 'usageStr', key: 'usageStr' },
  // {
  //   dataIndex: 'salePrice',
  //   key: 'salePrice',
  //   title: '销售价格'
  // },
  {
    dataIndex: 'remark',
    key: 'remark',
    title: '备注'
  }
]
//协定方明细
const AGREEMENT_DRUG_ADD = [
  { label: '剂型', value: 'dosageTypeStr' },
  { label: '用法用量', value: 'usageStr' },
  // { label: '用药周期', value: 'medicalCycle' }, //只在协定方展示
  { label: '嘱托', value: 'taboo' },
  { label: '药房备注', value: 'pharmacyRemark' }
]
//辅助方
const HEALTH_DRUG = [
  { title: 'sku 编码', dataIndex: 'skuCode', key: 'skuCode' },
  { title: 'sku 名称', dataIndex: 'skuName', key: 'skuName' },
  { title: '数量（盒）', dataIndex: 'quantity', key: 'quantity' },
  // {
  //   dataIndex: 'salePrice',
  //   key: 'salePrice',
  //   title: '销售价格'
  // },
  {
    dataIndex: 'remark',
    key: 'remark',
    title: '备注'
  }
]
export {
  BASE_LABEL,
  // statusImg,
  AGREEMENT_DRUG,
  WESTERN_DRUG,
  CHINESE_DRUG,
  AGREEMENT_DRUG_ADD,
  HEALTH_DRUG
}
